import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useGoto from '~/hooks/use-goto';
import { SettingsCache } from '~/lib/consts/settings-cache';

const Rewards = lazy(() => import('~/apps/rewards/rewards'));

export default function Component() {
  const { goTo } = useGoto();
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.REWARDS);

  useOnLoad(() => {
    if (!SettingsCache.settings.Features.includes('Rewards')) {
      goTo(RoutingConstants.MyAccount);
      return;
    }

    const title = t('REWARDS_PAGE_TITLE', { defaultValue: 'Rewards' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.REWARDS });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Rewards }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Rewards
      }
    });
  });

  return (
    <Tagged tag="screen-rewards">
      <Suspense>
        <Rewards />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'Rewards';
